module.exports = __webpack_public_path__ + "img/play-button.06601984.png";